var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "town",
    xmlns: "http://www.w3.org/2000/svg",
    width: 369.519,
    height: 269.007,
    viewBox: "0 0 369.519 269.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M523.291,361.728,503.8,330.72,483.31,359.868v59.895h39.981Z",
    transform: "translate(-217.508 -151.016)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M523.291,361.728,503.8,330.72,483.31,359.868v59.895h39.981Z",
    transform: "translate(-217.508 -151.016)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M513.93,330.72h63.254l19.8,32.012H578.395l-12.814-21.352-13.316,20.349H533.422Z",
    transform: "translate(-227.639 -151.016)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 3.493,
    height: 9.261,
    transform: "translate(291.671 221.298)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 3.493,
    height: 9.261,
    transform: "translate(276.281 221.298)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 3.493,
    height: 9.261,
    transform: "translate(291.671 244.175)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 3.493,
    height: 9.261,
    transform: "translate(276.281 244.175)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M579.666,334.647c0,.054-14.105.1-31.5.1s-31.5-.047-31.5-.1,14.1-.107,31.5-.107S579.666,334.587,579.666,334.647Z",
    transform: "translate(-228.542 -152.28)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M582.356,339.02c0,.06-14.105.107-31.5.107s-31.51-.047-31.51-.107,14.105-.1,31.51-.1S582.356,338.974,582.356,339.02Z",
    transform: "translate(-229.432 -153.729)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M585.246,343.687c0,.054-14.105.1-31.5.1s-31.5-.047-31.5-.1,14.105-.107,31.5-.107S585.246,343.627,585.246,343.687Z",
    transform: "translate(-230.388 -155.271)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M588.136,348.347c0,.054-14.105.1-31.5.1s-31.5-.047-31.5-.1,14.1-.107,31.5-.107S588.136,348.287,588.136,348.347Z",
    transform: "translate(-231.345 -156.813)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M591.023,353.007c0,.06-14.112.107-31.5.107s-31.51-.047-31.51-.107,14.105-.107,31.51-.107S591.023,352.967,591.023,353.007Z",
    transform: "translate(-232.297 -158.355)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M593.906,357.667c0,.06-14.105.107-31.5.107s-31.5-.047-31.5-.107,14.105-.107,31.5-.107S593.906,357.607,593.906,357.667Z",
    transform: "translate(-233.254 -159.896)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M596.846,362.33c0,.06-14.105.107-31.5.107s-31.5-.047-31.5-.107,14.1-.1,31.5-.1S596.846,362.277,596.846,362.33Z",
    transform: "translate(-234.226 -161.441)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M599.683,366.95c0,.06-14.105.107-31.5.107s-31.51-.047-31.51-.107,14.105-.1,31.51-.1S599.683,366.95,599.683,366.95Z",
    transform: "translate(-235.163 -162.97)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M602.566,371.657c0,.054-14.105.1-31.5.1s-31.5-.047-31.5-.1,14.105-.107,31.5-.107S602.566,371.6,602.566,371.657Z",
    transform: "translate(-236.119 -164.525)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M605.456,376.317c0,.054-14.105.1-31.5.1s-31.5-.047-31.5-.1,14.1-.107,31.5-.107S605.456,376.257,605.456,376.317Z",
    transform: "translate(-237.075 -166.067)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M606.621,425.033V368H588.033L575.219,346.65,561.9,367H543.06v58.034Z",
    transform: "translate(-237.277 -156.287)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M578.064,346.65l-26.4.415L564.668,367Z",
    transform: "translate(-240.122 -156.287)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 3.493,
    height: 9.261,
    transform: "translate(335.821 202.528)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 3.493,
    height: 9.261,
    transform: "translate(283.407 199.785)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 3.493,
    height: 9.261,
    transform: "translate(318.443 221.298)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 3.493,
    height: 9.261,
    transform: "translate(335.674 221.298)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 3.493,
    height: 9.261,
    transform: "translate(352.911 221.298)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 3.493,
    height: 9.261,
    transform: "translate(318.436 245.025)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 3.493,
    height: 9.261,
    transform: "translate(335.667 245.025)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 3.493,
    height: 9.261,
    transform: "translate(352.904 245.025)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M586.853,415.634c0,.1-23.179.174-51.771.174s-51.771-.074-51.771-.174,23.172-.174,51.771-.174S586.853,415.54,586.853,415.634Z",
    transform: "translate(-217.508 -179.053)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M483.254,419.737a2.286,2.286,0,0,1,0-.288v-4.142c0-2.891,0-7.093-.047-12.392,0-10.619-.04-25.628-.067-43.233v-.047l.033-.047,20.181-28.733.3-.422.147-.214.141.221c6.912,11,13.5,21.479,19.485,31.021v.08c0,17.05-.047,31.557-.06,41.808,0,5.119-.033,9.167-.047,11.958V419.3a2.226,2.226,0,0,1,0,.281v-4.269c0-2.79,0-6.839-.047-11.958,0-10.251-.04-24.758-.067-41.808v.087L503.7,330.621h.288l-.294.422-20.208,28.719.034-.094c0,17.605-.047,32.614-.067,43.233,0,5.3-.033,9.5-.047,12.392v4.142A.443.443,0,0,1,483.254,419.737Z",
    transform: "translate(-217.452 -150.851)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M637.964,435.725c-.094,0-.174-12.8-.174-28.592s.08-28.592.174-28.592.174,12.8.174,28.592S638.058,435.725,637.964,435.725Z",
    transform: "translate(-268.619 -166.838)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M250.618,270.5l-19.5-31.015L210.63,268.644v59.888h39.988Z",
    transform: "translate(-127.289 -120.832)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M250.618,270.5l-19.5-31.015L210.63,268.644v59.888h39.988Z",
    transform: "translate(-127.289 -120.832)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M241.25,239.49H304.5l19.8,32.018H305.715L292.9,250.156,279.592,270.5H260.749Z",
    transform: "translate(-137.42 -120.832)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 3.493,
    height: 9.261,
    transform: "translate(109.21 160.259)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 3.493,
    height: 9.261,
    transform: "translate(93.827 160.259)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 3.493,
    height: 9.261,
    transform: "translate(109.21 183.137)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 3.493,
    height: 9.261,
    transform: "translate(93.827 183.137)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M306.986,243.417c0,.054-14.105.1-31.5.1s-31.5-.047-31.5-.1,14.105-.107,31.5-.107S306.986,243.357,306.986,243.417Z",
    transform: "translate(-138.323 -122.095)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M309.686,247.8c0,.054-14.105.1-31.5.1s-31.5-.047-31.5-.1,14.1-.107,31.5-.107S309.686,247.737,309.686,247.8Z",
    transform: "translate(-139.216 -123.545)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M312.566,252.457c0,.06-14.105.107-31.5.107s-31.51-.047-31.51-.107,14.105-.107,31.51-.107S312.566,252.4,312.566,252.457Z",
    transform: "translate(-140.169 -125.086)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M315.456,257.12c0,.06-14.105.107-31.5.107s-31.5-.047-31.5-.107,14.105-.1,31.5-.1S315.456,257.067,315.456,257.12Z",
    transform: "translate(-141.125 -126.632)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M318.346,261.78c0,.06-14.105.107-31.5.107s-31.5-.047-31.5-.107,14.1-.1,31.5-.1S318.346,261.727,318.346,261.78Z",
    transform: "translate(-142.082 -128.173)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M321.233,266.44c0,.06-14.105.107-31.5.107s-31.51-.047-31.51-.107,14.105-.1,31.51-.1S321.233,266.387,321.233,266.44Z",
    transform: "translate(-143.034 -129.715)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M324.116,271.107c0,.054-14.105.1-31.5.1s-31.5-.047-31.5-.1,14.105-.107,31.5-.107S324.116,271.047,324.116,271.107Z",
    transform: "translate(-143.991 -131.257)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M327.006,275.767c0,.054-14.105.1-31.5.1s-31.5-.047-31.5-.1,14.1-.107,31.5-.107S327.006,275.707,327.006,275.767Z",
    transform: "translate(-144.947 -132.799)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M329.893,280.427c0,.06-14.105.107-31.5.107s-31.51-.047-31.51-.107,14.105-.107,31.51-.107S329.893,280.367,329.893,280.427Z",
    transform: "translate(-145.9 -134.341)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M332.776,285.087c0,.06-14.105.107-31.5.107s-31.5-.047-31.5-.107,14.105-.107,31.5-.107S332.776,285.027,332.776,285.087Z",
    transform: "translate(-146.856 -135.882)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M332.359,333.806c0-1,.154-56.957.154-56.957l-17.177-.067L302.522,255.43l-13.309,20.349H270.39v58.028Z",
    transform: "translate(-147.061 -126.106)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M305.388,255.43l-26.4.408L292,275.779Z",
    transform: "translate(-149.906 -126.106)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 3.493,
    height: 9.261,
    transform: "translate(153.36 141.483)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 3.493,
    height: 9.261,
    transform: "translate(100.946 138.739)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 3.493,
    height: 9.261,
    transform: "translate(135.982 160.259)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 3.493,
    height: 9.261,
    transform: "translate(153.219 160.259)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 3.493,
    height: 9.261,
    transform: "translate(170.45 160.259)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 3.493,
    height: 9.261,
    transform: "translate(135.976 183.98)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 3.493,
    height: 9.261,
    transform: "translate(153.213 183.98)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 3.493,
    height: 9.261,
    transform: "translate(170.443 183.98)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M313.43,324.414c0,.094-23.012.174-51.4.174s-51.4-.08-51.4-.174,23.012-.174,51.4-.174S313.43,324.314,313.43,324.414Z",
    transform: "translate(-127.289 -148.872)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M250.541,328.353V324.1c0-2.77,0-6.805-.047-11.9,0-10.2-.04-24.638-.067-41.614v.087L230.9,239.425h.294l-.254.355-20.248,29.054v-.094c0,17.485-.047,32.386-.06,42.932,0,5.259-.04,9.428-.047,12.3v0c0-2.871,0-7.039-.047-12.3,0-10.546,0-25.427-.06-42.932v-.094l20.235-29.061.248-.361.147-.214.141.221L250.715,270.5v.087c0,16.976-.047,31.409-.06,41.614,0,5.092-.033,9.127-.047,11.9v3.975A2.173,2.173,0,0,1,250.541,328.353Z",
    transform: "translate(-127.239 -120.673)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M363.174,287.44c.1,0,.174,12.64.174,28.218s-.074,28.224-.174,28.224S363,331.249,363,315.658,363.08,287.44,363.174,287.44Z",
    transform: "translate(-177.702 -136.696)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 57.693,
    height: 180.748,
    transform: "translate(33.43 87.898)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M284.463,321.51h-62.2v36.963h78.43Z",
    transform: "translate(-131.137 -147.969)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 72.12,
    height: 58.148,
    transform: "translate(91.123 210.504)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M172.26,265.67h7.461V252.154a3.734,3.734,0,0,0-3.734-3.734h0a3.734,3.734,0,0,0-3.727,3.734Z",
    transform: "translate(-114.594 -123.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M172.225,265.562a2.462,2.462,0,0,1,0-.442v-1.338c0-1.211-.033-2.891-.06-4.952v-5.367a17.967,17.967,0,0,1,.047-2.061,3.894,3.894,0,0,1,7.742.729v6.33c0,2.643,0,5.045-.033,7.093v.134h-.127l-5.494-.067-1.472-.033a2.406,2.406,0,0,1-.5,0h.542l1.5-.033,5.42-.067-.127.127c0-2.048,0-4.45-.033-7.093v-6.33a3.627,3.627,0,0,0-.569-2.007,3.56,3.56,0,0,0-6.511,1.338,19.573,19.573,0,0,0-.054,2.007c0,.669,0,1.285,0,1.894v3.406c0,2.061-.047,3.747-.06,4.958v1.338A.478.478,0,0,1,172.225,265.562Z",
    transform: "translate(-114.558 -123.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M163.289,62.16l-32.079,87.9h63.307Z",
    transform: "translate(-101.012 -62.16)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M192.111,173.044c0,.1-11.971.174-26.766.174s-26.766-.074-26.766-.174,11.971-.174,26.766-.174S192.111,172.957,192.111,173.044Z",
    transform: "translate(-103.45 -98.79)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M193.351,181.434c0,.1-12.774.174-28.525.174s-28.525-.074-28.525-.174,12.767-.174,28.525-.174S193.351,181.34,193.351,181.434Z",
    transform: "translate(-102.696 -101.566)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M190.947,163.284c0,.1-10.94.174-24.43.174s-24.437-.074-24.437-.174,10.94-.174,24.437-.174S190.947,163.19,190.947,163.284Z",
    transform: "translate(-104.608 -95.56)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M189.914,154.091a1.967,1.967,0,0,1-.448.04h-1.291l-4.758.06-15.671.047-15.685-.047-4.751-.06h-1.291a1.967,1.967,0,0,1-.448-.04,2.343,2.343,0,0,1,.448,0l1.291-.033,4.751-.054,15.685-.054,15.671.054,4.758.054,1.291.033a2.342,2.342,0,0,1,.448,0Z",
    transform: "translate(-105.763 -92.53)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M188.837,144.914c0,.1-8.933.174-19.954.174s-19.954-.074-19.954-.174,8.933-.174,19.954-.174S188.837,144.787,188.837,144.914Z",
    transform: "translate(-106.875 -89.482)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M187.754,135.654c0,.1-7.936.174-17.725.174s-17.739-.074-17.739-.174,7.943-.174,17.739-.174S187.754,135.56,187.754,135.654Z",
    transform: "translate(-107.986 -86.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M186.731,126.444c0,.094-6.912.174-15.437.174s-15.444-.08-15.444-.174,6.912-.174,15.444-.174S186.731,126.35,186.731,126.444Z",
    transform: "translate(-109.164 -83.371)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M185.618,117.234a5.7,5.7,0,0,1-1.044.067l-2.851.054c-2.409,0-5.728.054-9.4.054s-6.993,0-9.368-.054L160.1,117.3a5.614,5.614,0,0,1-1.044-.067,5.614,5.614,0,0,1,1.044-.067l2.851-.054c2.4,0,5.728-.054,9.368-.054s6.992,0,9.4.054l2.851.054a5.694,5.694,0,0,1,1.044.067Z",
    transform: "translate(-110.226 -80.324)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M184.528,108.024a4.015,4.015,0,0,1-.87.067l-2.375.054c-2.007,0-4.771.054-7.829.054s-5.828,0-7.829-.054l-2.375-.054a3.928,3.928,0,0,1-.87-.067,3.928,3.928,0,0,1,.87-.067l2.375-.054c2.007-.033,4.771-.054,7.829-.054s5.822,0,7.829.054l2.375.054A4.015,4.015,0,0,1,184.528,108.024Z",
    transform: "translate(-111.325 -77.277)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M183.472,98.814a2.549,2.549,0,0,1-.669.067c-.448,0-1.1.04-1.894.054-1.606,0-3.814.054-6.263.054s-4.684,0-6.256-.054a18.619,18.619,0,0,1-1.9-.054,2.549,2.549,0,0,1-.669-.067,2.55,2.55,0,0,1,.669-.067c.448,0,1.1-.04,1.9-.054,1.6,0,3.814-.054,6.256-.054s4.684,0,6.263.054a18.544,18.544,0,0,1,1.894.054,2.55,2.55,0,0,1,.669.067Z",
    transform: "translate(-112.463 -74.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M182.369,89.6a12.171,12.171,0,0,1-2.088.12l-2.268.04h-2.489V89.41h.422V89.8h-2.489l-2.268-.04a12.251,12.251,0,0,1-2.088-.12,12.607,12.607,0,0,1,2.088-.127h4.758V89.8h-.422v-.348h4.758A12.513,12.513,0,0,1,182.369,89.6Z",
    transform: "translate(-113.548 -71.176)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M181.314,81.524a31.122,31.122,0,0,1-4.61.174,31,31,0,0,1-4.6-.174,30.994,30.994,0,0,1,4.6-.174A31.122,31.122,0,0,1,181.314,81.524Z",
    transform: "translate(-114.541 -68.502)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M180.936,73.214a27.671,27.671,0,0,1-6.2,0,27.673,27.673,0,0,1,6.2,0Z",
    transform: "translate(-115.414 -65.753)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M193.991,274.114c0,.1-12.8.174-28.586.174s-28.586-.074-28.586-.174,12.794-.174,28.586-.174S193.991,274.02,193.991,274.114Z",
    transform: "translate(-102.868 -132.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M193.991,280.914c0,.1-12.8.174-28.586.174s-28.586-.074-28.586-.174,12.794-.174,28.586-.174S193.991,280.827,193.991,280.914Z",
    transform: "translate(-102.868 -134.48)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M185.239,250.014a.536.536,0,0,1,0-.181v-2.65c0-1.853,0-4.537-.047-7.9,0-6.778-.04-16.334-.067-27.488l.047.12c-3.272-3.279-6.832-6.832-10.526-10.519l.12.054H166.73l.12-.054-10.887,10.88.047-.114c0,11.047-.047,20.5-.067,27.221,0,3.346-.033,5.989-.047,7.829v2.623a.536.536,0,0,1,0,.181.931.931,0,0,1,0-.181V247.21c0-1.84,0-4.49-.047-7.829,0-6.691-.033-16.173-.06-27.221v-.074l.047-.047,10.8-10.894.047-.047h8.13l.054.047,10.505,10.532.047.047v.067c0,11.155-.047,20.71-.06,27.488,0,3.346,0,6.022-.047,7.9v2.65A.209.209,0,0,1,185.239,250.014Z",
    transform: "translate(-109.144 -108.13)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M301.166,431.718c-3.633-.134-7.5.89-10.766-.709-3.747-1.84-5.353-6.511-8.9-8.7-3.807-2.322-8.819-1.164-12.714,1.03s-7.207,5.353-11.255,7.18c-5.688,2.61-12.225,2.469-18.261,4.122s-12.044,8.9-11.717,15.143l89.611-.214C317.051,441.18,309.577,432.026,301.166,431.718Z",
    transform: "translate(-132.884 -180.898)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M135.214,362.97c-.1,0-.174-37.559-.174-83.883s.074-83.9.174-83.9.174,37.552.174,83.9S135.308,362.97,135.214,362.97Z",
    transform: "translate(-102.279 -106.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M222.724,289.46c-.1,0-.174-20.83-.174-46.512s.074-46.519.174-46.519.174,20.824.174,46.519S222.851,289.46,222.724,289.46Z",
    transform: "translate(-131.233 -106.585)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M287.192,328.594c0,.094-14.453.174-32.286.174s-32.286-.08-32.286-.174,14.453-.174,32.286-.174S287.192,328.5,287.192,328.594Z",
    transform: "translate(-131.256 -150.255)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M288.4,334.421c0,.094-14.721.174-32.888.174s-32.895-.08-32.895-.174,14.721-.181,32.895-.181S288.4,334.32,288.4,334.421Z",
    transform: "translate(-131.256 -152.181)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M290.364,340.434c0,.1-15.169.174-33.872.174s-33.872-.074-33.872-.174,15.163-.174,33.872-.174S290.364,340.34,290.364,340.434Z",
    transform: "translate(-131.256 -154.172)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M292.05,346.844c0,.1-15.544.174-34.715.174s-34.715-.074-34.715-.174,15.537-.174,34.715-.174S292.05,346.75,292.05,346.844Z",
    transform: "translate(-131.256 -156.293)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M293.937,353.254c0,.094-15.966.174-35.658.174s-35.658-.08-35.658-.174,15.959-.174,35.658-.174S293.937,353.16,293.937,353.254Z",
    transform: "translate(-131.256 -158.414)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M295.643,359.664c0,.094-16.347.174-36.508.174s-36.515-.08-36.515-.174,16.347-.174,36.515-.174S295.643,359.564,295.643,359.664Z",
    transform: "translate(-131.256 -160.535)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M297.524,366.064c0,.1-16.775.174-37.472.174s-37.472-.074-37.472-.174,16.769-.174,37.472-.174S297.524,365.964,297.524,366.064Z",
    transform: "translate(-131.243 -162.652)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M296.483,372.474c0,.1-16.534.174-36.923.174s-36.93-.074-36.93-.174,16.528-.174,36.93-.174S296.483,372.38,296.483,372.474Z",
    transform: "translate(-131.259 -164.773)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M222.046,435.2c-.094,0-.254-12.881-.355-28.773s-.107-28.773,0-28.773.261,12.874.361,28.773S222.14,435.2,222.046,435.2Z",
    transform: "translate(-130.923 -166.543)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M222.26,321.51l20.924,36.963H222.5Z",
    transform: "translate(-131.137 -147.969)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M136.04,193.52l57.693,5.246V193.52Z",
    transform: "translate(-102.61 -105.622)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M148.7,330.72,116.51,362.745h63.756Z",
    transform: "translate(-96.148 -151.016)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 76.041,
    height: 56.877,
    transform: "translate(4.865 211.736)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 7.407,
    height: 16.782,
    transform: "translate(53.933 252.011)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 25.815,
    height: 57.071,
    transform: "translate(4.865 211.736)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M138.627,330.72H118.306L86.08,362.745h24.5Z",
    transform: "translate(-86.08 -151.016)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 3.165,
    height: 9.502,
    transform: "translate(43.581 237.424)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 3.165,
    height: 9.502,
    transform: "translate(67.215 237.424)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 3.165,
    height: 9.502,
    transform: "translate(43.581 218.293)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 3.165,
    height: 9.502,
    transform: "translate(16.836 237.424)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 3.165,
    height: 9.502,
    transform: "translate(16.836 218.293)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 3.165,
    height: 9.502,
    transform: "translate(67.215 218.293)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M168.873,373.86c0,.06-17.344.107-38.736.107S91.4,373.921,91.4,373.86s17.337-.1,38.736-.1S168.873,373.807,168.873,373.86Z",
    transform: "translate(-87.84 -165.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M166.35,368.36c0,.06-15.772.107-35.223.107s-35.237-.047-35.237-.107,15.772-.1,35.237-.1S166.35,368.307,166.35,368.36Z",
    transform: "translate(-89.326 -163.437)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M165.176,362.86c0,.06-14.112.107-31.51.107s-31.516-.047-31.516-.107,14.105-.1,31.516-.1S165.176,362.807,165.176,362.86Z",
    transform: "translate(-91.397 -161.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M163.28,357.36c0,.06-12.513.107-27.95.107s-27.95-.047-27.95-.107,12.513-.1,27.95-.1S163.28,357.307,163.28,357.36Z",
    transform: "translate(-93.127 -159.797)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M161.393,351.91h-7.14l-17.237.033-17.237.027H114.56l5.219-.033h34.474l5.226.033H160.9Z",
    transform: "translate(-94.868 -158.027)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M159.174,346.36c0,.06-9.12.107-20.362.107s-20.362-.047-20.362-.107,9.114-.1,20.362-.1S159.174,346.307,159.174,346.36Z",
    transform: "translate(-96.79 -156.158)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M158.156,340.91a1.292,1.292,0,0,1-.348,0l-1.024.06h-3.66L141.08,341l-12.091-.033h-4.651a1.292,1.292,0,0,1-.348,0,2.348,2.348,0,0,1,.348,0h1l3.66-.033h24.129l3.66.033h1A2.35,2.35,0,0,1,158.156,340.91Z",
    transform: "translate(-98.623 -154.388)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M156.7,335.393a.8.8,0,0,1-.274,0h-3.707l-9.609.033-9.616-.033h-3.707a.8.8,0,0,1-.274,0,1.464,1.464,0,0,1,.274,0h.8l2.911-.033h19.224l2.911.033h.8A1.461,1.461,0,0,1,156.7,335.393Z",
    transform: "translate(-100.449 -152.551)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M138.627,330.72H118.306L86.08,362.745h24.5Z",
    transform: "translate(-86.08 -151.016)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M206.98,435.619a3.127,3.127,0,0,1-.04-.569v-7.715c0-5.112.087-12.185.214-19.987s.234-14.848.315-19.994c.04-2.536.067-4.6.087-6.062,0-.669,0-1.238.04-1.646a2.982,2.982,0,0,1,.033-.575,2.984,2.984,0,0,1,0,.575c0,.408,0,.957.033,1.646v6.062c0,5.119-.087,12.185-.214,19.994s-.234,14.848-.321,19.994c0,2.529-.067,4.59-.087,6.056v1.653a5.354,5.354,0,0,1-.06.569Z",
    transform: "translate(-126.068 -167.013)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M93.207,435.763c-.094,0-.214-12.714-.268-28.432s0-28.432.074-28.432.214,12.714.274,28.432S93.307,435.763,93.207,435.763Z",
    transform: "translate(-88.342 -166.957)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M131.7,436.024c-.094,0-.174-12.747-.174-28.472s.08-28.472.174-28.472.174,12.747.174,28.472S131.8,436.024,131.7,436.024Z",
    transform: "translate(-101.118 -167.016)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M457.524,242.5a7.976,7.976,0,0,0-3.306-4.49,4.871,4.871,0,0,0-5.353.147c-2.677,2.1-1.874,6.752-4.463,8.94-2.362,2.007-5.9.763-8.98.95a9.435,9.435,0,0,0-7.247,4.236c-1.425,2.208-1.941,5.052-3.935,6.758-4.015,3.466-11.108,0-15.236,3.346a7.6,7.6,0,0,0-2.509,5.226,22.643,22.643,0,0,0,.482,5.922l4.1-.033c-.261-2.416-.422-5.166,1.251-6.926s4.684-1.726,7.207-1.251a52.519,52.519,0,0,0,6.959,1.191,9.94,9.94,0,0,0,6.691-1.767c2.322-1.833,3.406-5.085,6.062-6.39,2.322-1.151,5.085-.435,7.675-.549a11.723,11.723,0,0,0,10.626-15.33Z",
    transform: "translate(-192.084 -120.1)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M332.99,408.453V351.383l61.1-54.843h12.76l45.026,54.247v57.666Z",
    transform: "translate(-167.773 -139.707)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M328.97,351.5h36.16l40.389-54.956H370.162Z",
    transform: "translate(-166.443 -139.707)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M417.592,300.353V285.94H399.98v24.731h10.044Z",
    transform: "translate(-189.937 -136.2)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M365.323,378.67l.214,56.957H332.99V378.67Z",
    transform: "translate(-167.773 -166.881)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 6.678,
    height: 15.885,
    transform: "translate(239.077 252.861)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 3.339,
    height: 9.756,
    transform: "translate(212.88 234.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 3.339,
    height: 9.756,
    transform: "translate(212.88 209.842)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 3.339,
    height: 9.756,
    transform: "translate(240.174 234.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 3.339,
    height: 9.756,
    transform: "translate(240.174 208.925)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 3.339,
    height: 9.756,
    transform: "translate(240.174 182.374)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 3.339,
    height: 9.756,
    transform: "translate(267.468 234.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 3.339,
    height: 9.756,
    transform: "translate(267.468 208.925)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 10.05,
    height: 24.738,
    transform: "translate(210.043 149.74)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M332.914,436.07c-.1,0-.174-12.52-.174-27.95s.074-27.95.174-27.95.174,12.506.174,27.95S333,436.07,332.914,436.07Z",
    transform: "translate(-167.69 -167.377)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M381.114,435.413c-.094,0-.174-12.714-.174-28.371s.08-28.371.174-28.371.174,12.714.174,28.371S381.208,435.413,381.114,435.413Z",
    transform: "translate(-183.638 -166.881)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M510.624,435.546c-.094,0-.1-12.868,0-28.773s.241-28.773.335-28.773.1,12.868,0,28.773S510.724,435.546,510.624,435.546Z",
    transform: "translate(-226.521 -166.659)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M422.535,286.42a1.421,1.421,0,0,1,0,.268v.783c0,.743,0,1.713.033,2.884v10.178h0l-5.387,7.3-1.639,2.181-.455.582c-.1.134-.161.2-.167.194a1.026,1.026,0,0,1,.141-.214c.114-.174.254-.375.422-.609l1.579-2.222c1.4-1.914,3.259-4.477,5.353-7.361v-.609c0-3.687,0-7.013.033-9.508,0-1.171,0-2.141.033-2.884V286.6A1.422,1.422,0,0,1,422.535,286.42Z",
    transform: "translate(-194.88 -136.359)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M443.37,296.54,488.4,350.787l2.188-.83L445.712,296.54Z",
    transform: "translate(-204.293 -139.707)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M405.519,296.54a1.053,1.053,0,0,1-.141.228c-.114.161-.268.375-.455.669l-1.773,2.469-6.578,9.027-21.814,29.757c-3.346,4.53-6.551,8.893-9.5,12.908l-.054.067h-.087l-25.969-.067-7.488-.047h-2.7a.509.509,0,0,1,.174,0h2.523l7.5-.053,25.969-.06L365,351.5l9.488-13.021,21.894-29.7,6.691-8.98,1.827-2.429.482-.629Z",
    transform: "translate(-166.443 -139.707)",
    fill: "#263238"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTown);
export default __webpack_public_path__ + "static/media/town.c88fc029b08e9b4496ca6459cfc97b91.svg";
export { ForwardRef as ReactComponent };